import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  HiMenu,
  HiChevronDown,
  HiUser,
  HiLogout
} from 'react-icons/hi';
import './Header.css';

const Header = ({ onMenuToggle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });
  const userMenuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target) &&
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      // Calcular posição do dropdown quando abrir (position: fixed é relativo ao viewport)
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setMenuPosition({
          top: rect.bottom + 8,
          right: window.innerWidth - rect.right
        });
      }

      // Usar setTimeout para garantir que o evento de abertura seja processado primeiro
      setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
      }, 0);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showUserMenu]);

  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.trim().split(' ');
    if (names.length === 1) return names[0].charAt(0).toUpperCase();
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuToggle}>
          <HiMenu size={24} />
        </button>
      </div>

      <div className="header-right">
        <div className="user-menu-wrapper" ref={userMenuRef}>
          <button
            ref={buttonRef}
            className="user-menu-btn"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowUserMenu(prev => !prev);
            }}
          >
            <div className="user-avatar-small">
              {getInitials(user?.nome)}
            </div>
            <div className="user-info-header">
              <span className="user-name-header">{user?.nome || 'Usuário'}</span>
            </div>
            <HiChevronDown size={18} className={`chevron ${showUserMenu ? 'open' : ''}`} />
          </button>

          {showUserMenu && (
            <div
              className="user-dropdown-menu"
              style={{
                top: `${menuPosition.top}px`,
                right: `${menuPosition.right}px`
              }}
            >
              <div className="dropdown-header">
                <div className="dropdown-avatar">
                  {getInitials(user?.nome)}
                </div>
                <div>
                  <div className="dropdown-name">{user?.nome || 'Usuário'}</div>
                  <div className="dropdown-email">{user?.email || ''}</div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={() => { navigate('/profile'); setShowUserMenu(false); }}>
                <HiUser size={18} />
                <span>Meu Perfil</span>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout" onClick={logout}>
                <HiLogout size={18} />
                <span>Sair</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;